import React, { useEffect, useState } from 'react';
import '../../styles/ProductPreviewGallery.css';

const ResumePreview = ({ enlarged = false }) => (
  <div className={`product-resume-sheet ${enlarged ? 'enlarged' : ''}`} aria-hidden="true">
    <div className="product-resume-header">
      <strong>SEU NOME</strong>
      <span>Objetivo profissional</span>
      <small>cidade • telefone • e-mail</small>
    </div>
    <div className="product-resume-section">
      <b>RESUMO PROFISSIONAL</b>
      <i /><i /><i className="short" />
    </div>
    <div className="product-resume-section">
      <b>EXPERIÊNCIA</b>
      <i /><i className="short" />
    </div>
    <div className="product-resume-section">
      <b>CURSOS E CERTIFICAÇÕES</b>
      <span>✓ Curso concluído na ABRALIBER</span>
      <i className="short" />
    </div>
  </div>
);

const ProductPreviewGallery = ({ showResume = true, compact = false }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!preview) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setPreview(null);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [preview]);

  return (
    <section className={`product-preview-gallery ${compact ? 'compact' : ''}`} aria-labelledby="product-preview-title">
      <div className="product-preview-heading">
        <span className="product-preview-kicker">
          {showResume ? 'Prévia dos produtos' : 'Prévia do certificado'}
        </span>
        <h3 id="product-preview-title">Veja o que você receberá</h3>
      </div>
      <div className={`product-preview-items ${showResume ? '' : 'certificate-only'}`}>
        <button type="button" className="product-preview-item" onClick={() => setPreview('certificate')}>
          <span className="product-certificate-crop">
            <img src="/certificado-modelo.png" alt="Prévia do Certificado digital ABRALIBER" />
          </span>
          <strong>Certificado digital</strong>
          <small>Toque para ampliar</small>
        </button>

        {showResume && (
          <button type="button" className="product-preview-item resume" onClick={() => setPreview('resume')}>
            <ResumePreview />
            <strong>Currículo profissional</strong>
            <small>Toque para ampliar</small>
          </button>
        )}
      </div>

      {preview && (
        <div className="product-preview-modal" role="presentation" onMouseDown={() => setPreview(null)}>
          <div
            className={`product-preview-dialog ${preview}`}
            role="dialog"
            aria-modal="true"
            aria-label={preview === 'certificate' ? 'Prévia ampliada do Certificado' : 'Prévia ampliada do currículo'}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="product-preview-close"
              aria-label="Fechar prévia"
              onClick={() => setPreview(null)}
              autoFocus
            >
              ×
            </button>
            {preview === 'certificate' ? (
              <span className="product-certificate-crop enlarged">
                <img src="/certificado-modelo.png" alt="Modelo ampliado do Certificado digital ABRALIBER" />
              </span>
            ) : (
              <ResumePreview enlarged />
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductPreviewGallery;
